import { render, staticRenderFns } from "./Laws.vue?vue&type=template&id=128d7660&"
import script from "./Laws.vue?vue&type=script&lang=js&"
export * from "./Laws.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports